<p class="text-title-lgx-bold">Información de contacto</p>
<p class="text-info-bold-xs mt-xxs mb-xs">DEJA QUE TUS PACIENTES TE CONTACTEN</p>

<nz-alert nzType="info"
  class="tw-w-full"
  nzMessage="Estos datos están protegidos bajo estándares de manejo de la información." nzShowIcon></nz-alert>
<div class="mt-sm tw-w-full">

  <p class="input-label-form mb-xs">Teléfono de la clínica</p>
  <form nz-row [nzGutter]="[16, 16]" #form="ngForm">
    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="5" nzXl="5">
      <p class="text-info mb-xs">TIPO</p>
      <nz-select [(ngModel)]="phone.type" [required]="true" nzPlaceHolder="Seleccione" name="type" #ngType="ngModel">
        <nz-option [nzValue]="phoneTypeEnum.CELLULAR" [nzLabel]="phoneTypeEnum.CELLULAR | getTranslateEnum:'phoneType'"></nz-option>
        <nz-option [nzValue]="phoneTypeEnum.LOCAL" [nzLabel]="phoneTypeEnum.LOCAL | getTranslateEnum:'phoneType'"></nz-option>
        <nz-option [nzValue]="phoneTypeEnum.FAX" [nzLabel]="phoneTypeEnum.FAX | getTranslateEnum:'phoneType'"></nz-option>
      </nz-select>
      <app-message-field [field]="ngType"></app-message-field>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="5" nzXl="5">
      <p class="text-info mb-xs">CÓDIGO ÁREA</p>
      <input [required]="true" type="text" nz-input placeholder="Código área" [(ngModel)]="phone.areaCode" name="areaCode" #ngAreaCode="ngModel"
        minlength="3"
        maxlength="3"
        (keyup)="this.helperValidationField.onValidateNumber(phone, 'areaCode')">
      <app-message-field [field]="ngAreaCode"></app-message-field>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="9" nzXl="9">
      <p class="text-info mb-xs">TELÉFONO</p>
      <input [required]="true" type="text" nz-input placeholder="Teléfono" [(ngModel)]="phone.phoneNumber" name="phone" #ngPhone="ngModel"
        minlength="7"
        maxlength="7"
        (keyup)="this.helperValidationField.onValidateNumber(phone, 'phoneNumber')">
      <app-message-field [field]="ngPhone"></app-message-field>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="5" nzXl="5">
      <p class="text-info mb-xs">EXTENSIÓN</p>
      <input type="text" nz-input placeholder="Extensión" [(ngModel)]="phone.ext" name="ext" #ngExt="ngModel"
        minlength="0"
        maxlength="5"
        (keyup)="this.helperValidationField.onValidateNumber(phone, 'ext')">
      <app-message-field [field]="ngExt"></app-message-field>
    </div>
  </form>
  <p class="input-label-form mt-xlg mb-xs">Correo de la clínica</p>
  <div nz-row nzGutter="16" style="width: 100%">
    <form nz-col nzSpan="24" #formEmail="ngForm">
      <p class="text-info mb-xs">CORREO ELECTRÓNICO</p>
      <input [required]="true" type="text" [(ngModel)]="clinicEmail" nz-input placeholder="Correo electrónico" name="clinicEmail"
        #ngClinicEmail="ngModel"
        (ngModelChange)="helperValidationField.onValidateEmail(clinicEmail, ngClinicEmail)">
      <app-message-field [field]="ngClinicEmail"></app-message-field>
    </form>
  </div>
